module.exports = __webpack_public_path__ + "static/media/nike-never-ask-medvedeva.08259227.mp4";